/**
 * @author：
 * @update：
 * @description：
 **/
import {goodsTypeGroupingList,goodsTypeGroupingAdd,delGoodsTypeGroupingList,editGoodsTypeGroupingList } from "../../api/url";
import CusPagination from '@/components/cusPagination.vue';
export default {
    components: {
        CusPagination,
    },
    data() {
        return {
            attrName:'',//属性名称
            attrContent:'',//属性内容
            description:'',//说明
            enableVal:'',//启禁用
            enableOption:[{value:'true',label:'启用'},{value:'false',label:'禁用'}],
            tableData:[],//数据列表
            page:1,
            size:10,
            count:0,

            //新增商品属性
            addGoodsAttributes:false,//新增商品属性弹窗
            goodsAttributesName:'',//新增商品属性名称
            goodsAttributesVal:[{name:''}],//新增商品属性内容
            goodsAttributesRadio:"RADIO",//选择形式
            textTypeValue:'STRING',//输入框类型
            minVal:'',//最小值
            maxVal:'',//最大值
            unit:'',//单位
            enabled:'',//启禁用
            unlimited:false,//是否显示无限制

            //编辑
            isEdit:false,//是否是编辑
            editId:'',//编辑的id
        };
    },
    // 自定义方法
    methods: {
        // 重置
        resetBtn(){
            this.attrName='';//属性名称
            this.attrContent='';//属性内容
            this.enableVal='';//启禁用
            this.page=1;
            this.size=10;
            this.dataList();
        },
        //获取列表
        dataList(){
            let data = {
                name:this.attrName,
                enabled:this.enableVal,
                value:this.attrContent,
                pageNumber:this.page,
                pageSize:this.size
            };
            this.$ajax.get(goodsTypeGroupingList,data).then(res=>{
                console.log(res);
                this.tableData = res.data.rows;
                this.count = res.data.total;
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        },
        //编辑
        editList(item){
            this.editId = item.id;
            this.isEdit = true;
            this.addGoodsAttributesClose();
            this.addGoodsAttributes=true;
            this.goodsAttributesName = item.name;
            this.description = item.description;
            this.goodsAttributesRadio = item.type;
            this.textTypeValue = item.valueType;
            if(item.type=="INPUT"){
                if(item.valueType=="NUMBER"){
                    this.minVal = item.min;
                    this.maxVal = item.max;
                    this.unit = item.unit;
                    this.unlimited = item.unlimited;
                }
            }
            if(item.type=='RADIO'||item.type=='CHECKBOX'||item.type=='SELECT'){
                let arr = [];
                let data = item.value.split(',');
                for(let i = 0; i < data.length; i++){
                    let obj = {name:data[i]};
                    arr.push(obj)
                }
                this.goodsAttributesVal = arr
            }
            this.enabled = item.enabled;
        },
        //删除
        delList(id){
            let enabled = this.tableData.filter((item)=>{return item.id===id})
            if(enabled[0].enabled){
                this.$message({
                    showClose:true,
                    message:'已开启的资源不支持删除',
                    type:'error',
                    center:true,
                    duration:3000
                })
                return false
            }
            this.$ajax.delete(delGoodsTypeGroupingList(id),{id:id}).then(res=>{
                console.log(res);
                this.$message({
                    showClose:true,
                    message:'删除成功',
                    type:'success',
                    center:true,
                    duration:3000
                })
                this.dataList();
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        },

        /*新增商品属性*/
        //选择形式选择重置数据
        goodsAttributesRadioChange(){
            this.goodsAttributesVal = [{name:''}];
            this.textTypeValue='STRING';//输入框类型
            this.minVal='';//最小值
            this.maxVal='';//最大值
            this.unit='';//单位
            this.unlimited=false;//是否显示无限制
            return false
        },
        //输入类型选择重置数据
        textTypeChange(){
            this.minVal='';//最小值
            this.maxVal='';//最大值
            this.unit='';//单位
            this.unlimited=false;//是否显示无限制
        },
        //添加属性
        addAttributes(){
            let data = this.goodsAttributesVal;
            data.push({name:''});
            this.goodsAttributesVal = data;
        },
        //删除对应属性
        delGoodsAttributesVal(index){
            let data = this.goodsAttributesVal;
            if(data.length==1){
                return false
            }
            data.splice(index,1)
        },
        //新增商品属性保存
        addGoodsAttributesBtn() {
            if(this.goodsAttributesName==''){
                this.$message({
                    showClose:true,
                    message:"请填写属性名称",
                    type:'error',
                    center:true,
                    duration:3000
                })
                return false
            }
            if(this.goodsAttributesRadio=='RADIO'||this.goodsAttributesRadio=='CHECKBOX'||this.goodsAttributesRadio=='SELECT'){
                for(let i = 0; i < this.goodsAttributesVal.length; i++){
                    if(this.goodsAttributesVal[i].name==''){
                        this.$message({
                            showClose:true,
                            message:"请填写输入类型",
                            type:'error',
                            center:true,
                            duration:3000
                        })
                        return false
                    }
                }
            }
            let data = {
                name:this.goodsAttributesName,
                description:this.description,
                type:this.goodsAttributesRadio
            };
            if(this.goodsAttributesRadio=='RADIO'||this.goodsAttributesRadio=='CHECKBOX'||this.goodsAttributesRadio=='SELECT'){
                let arr = [];
                for(let i = 0; i < this.goodsAttributesVal.length; i++){
                    if(this.goodsAttributesVal[i].name!=''){
                        arr.push(this.goodsAttributesVal[i].name)
                    }
                }
                data.value = arr.join(',');
            }
            if(this.goodsAttributesRadio=='INPUT'){
                data.valueType = this.textTypeValue;
            }
            if(this.textTypeValue=='NUMBER'){
                data.min = this.minVal;
                data.max = this.maxVal;
                data.unit = this.unit;
                data.unlimited = this.unlimited;
            }
            if(this.isEdit==false){
                //新增
                this.$ajax.post(goodsTypeGroupingAdd,data).then(res=>{
                    console.log(res);
                    this.dataList();
                    this.addGoodsAttributesClose();
                },err=>{
                    console.log(err);
                    this.$message({
                        showClose:true,
                        message:err.data,
                        type:'error',
                        center:true,
                        duration:3000
                    })
                })
            }else{
                //修改
                data.id = this.editId;
                data.enabled = this.enabled;
                this.$ajax.put(editGoodsTypeGroupingList(this.editId),data).then(res=>{
                    console.log(res);
                    this.dataList();
                    this.addGoodsAttributesClose();
                },err=>{
                    console.log(err);
                    this.$message({
                        showClose:true,
                        message:err.data,
                        type:'error',
                        center:true,
                        duration:3000
                    })
                })
            }

        },
        //取消
        addGoodsAttributesClose(){
            this.goodsAttributesName='';
            this.goodsAttributesRadio = 'RADIO';//选择形式
            this.goodsAttributesVal = [{name:''}];
            this.textTypeValue='STRING';//输入框类型
            this.description='';
            this.minVal='';//最小值
            this.maxVal='';//最大值
            this.unit='';//单位
            this.unlimited=false;//是否显示无限制
            this.enabled = '';
            this.addGoodsAttributes = false;//关闭窗口
        },

        //删除提示
        delOpen(fun,id) {
            this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                fun(id);
                // this.$message({
                //     type: 'success',
                //     message: '删除成功!'
                // });
            }).catch(() => {
                // this.$message({
                //     type: 'info',
                //     message: '已取消删除'
                // });
            });
        },
    },
    // 数据观察监听
    watch: {
        page(newData,oldData){
            this.dataList();
        },
        size(newData,oldData){
            this.page = 1;
            this.dataList();
        },
        goodsAttributesRadio(newData,oldData){
            if(newData=="INPUT"){
                this.goodsAttributesVal=[{name:''}]
            }
        },
    },
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {

    },
    // 组件挂载完成之前
    beforeMount() {
        this.dataList();
    },
    // 组件挂载完成
    mounted() {

    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
